/*@flow*/
import useField from './useField';
import { isInnerTypeList } from '../util';
import getTypeInfo from '../util/getTypeInfo';
import nested from 'lib/nested';
import type { PathT } from '../types';

type ComparableT = $Shape<{ text: string, value: string }>;

function sortByText(a: ComparableT, b: ComparableT) {
  return a.text.localeCompare(b.text);
}

function getComparator(order: 'asc' | 'desc') {
  return {
    asc: sortByText,
    desc: (a: ComparableT, b: ComparableT) => -sortByText(a, b),
  }[order];
}

function getEnum(typeInfo, isMultiple) {
  if (!isMultiple) return typeInfo.innerType;
  const type2 = nested(typeInfo, 'innerType.meta.type');
  const type2Info = getTypeInfo(type2);
  return nested(type2Info, 'innerType');
}

function getItemsOfEnum(type: any): { value: any, text: string }[] {
  const enums = nested<{}>(type, 'meta.map');
  if (!enums) return [];

  const fn = value => {
    return {
      value,
      text: enums[value],
    };
  };
  return Object.keys(enums).map(fn);
}

export default function useItems(path: PathT): any | Array<{text: string, value: any, ...}> {
  const { fieldOptions, typeInfo } = useField(path);
  const { options: items0, order } = fieldOptions;
  let items: ComparableT[] = [];
  if (items0) {
    items = items0.slice();
  } else {
    const isMultiple = isInnerTypeList(typeInfo);
    const enums = getEnum(typeInfo, isMultiple);
    items = getItemsOfEnum(enums);
  }
  order && items.sort(getComparator(order));
  return items;
}
